import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBubbles: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="bubbles, messages, chat, communicate"><path d="M2.75195 7.75H17.252V18.25H10.502L6.00195 20.75V18.25H2.75195V7.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M7.00195 7.75V3.75H21.252V14.25H17.3878" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconBubbles;
